<template>
    <div class="space-y-6">
        <!-- 后台任务管理 -->
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    后台任务管理
                </h2>
                <div class="mb-4 p-3 bg-info/10 rounded-lg border border-info/20">
                    <div class="text-sm text-base-content/80">
                        后台任务用于执行一些定时任务，例如刮削、删除等。
                    </div>
                </div>

                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <!-- 停止所有后台任务 -->
                    <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                        <div class="flex items-center mb-3">
                            <svg class="w-4 h-4 mr-2 text-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 4h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17.294 15M10 14L9 9m0 0L3 9l3.5-7 7 .5M9 9l5 5"></path>
                            </svg>
                            <h3 class="font-medium text-base-content">停止所有后台任务</h3>
                        </div>
                        
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm focus:select-primary" v-model="formData.backend_task.stop_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>
                        
                        <div v-if="formData.backend_task.stop_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm focus:input-primary" v-model="formData.backend_task.stop_task.cron" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div v-else-if="formData.backend_task.stop_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm focus:input-primary" v-model="formData.backend_task.stop_task.interval" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div class="flex items-center justify-between pt-2">
                            <div class="flex items-center gap-2">
                                <span class="text-sm font-medium">启用状态</span>
                                <div class="badge badge-sm text-white" :class="formData.backend_task.stop_task.enabled ? 'badge-success' : 'badge-error'">
                                    {{ formData.backend_task.stop_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="btn btn-sm btn-primary" @click="handleTask2('stop_task', formData.backend_task.stop_task)">立即执行</button>
                                <button class="btn btn-sm btn-outline" @click="handleTask2('stop_task', formData.backend_task.stop_task, false)">关闭</button>
                            </div>
                        </div>
                        
                        <div class="text-sm text-base-content/70 flex items-center gap-2 pt-2 border-t border-base-300">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.stop_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 刮削艺术家封面 -->
                    <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                        <div class="flex items-center mb-3">
                            <svg class="w-4 h-4 mr-2 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                            </svg>
                            <h3 class="font-medium text-base-content">刮削艺术家封面</h3>
                        </div>
                        
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm focus:select-secondary" v-model="formData.backend_task.artist_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>
                        
                        <div v-if="formData.backend_task.artist_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm focus:input-secondary" v-model="formData.backend_task.artist_task.cron" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div v-else-if="formData.backend_task.artist_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm focus:input-secondary" v-model="formData.backend_task.artist_task.interval" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div class="flex items-center justify-between pt-2">
                            <div class="flex items-center gap-2">
                                <span class="text-sm font-medium">启用状态</span>
                                <div class="badge badge-sm text-white" :class="formData.backend_task.artist_task.enabled ? 'badge-success' : 'badge-error'">
                                    {{ formData.backend_task.artist_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="btn btn-sm btn-primary" @click="handleTask2('artist_task', formData.backend_task.artist_task)">立即执行</button>
                                <button class="btn btn-sm btn-outline" @click="handleTask2('artist_task', formData.backend_task.artist_task, false)">关闭</button>
                            </div>
                        </div>
                        
                        <div class="text-sm text-base-content/70 flex items-center gap-2 pt-2 border-t border-base-300">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.artist_task.last_run || '未执行' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 删除管理 -->
        <div class="card bg-base-100 shadow-lg border border-base-200">
            <div class="card-body">
                <h2 class="card-title text-lg font-semibold mb-4 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                    </svg>
                    删除管理
                </h2>
                
                <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                    <!-- 音乐收藏 -->
                    <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                        <div class="flex items-center mb-3">
                            <svg class="w-4 h-4 mr-2 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"></path>
                            </svg>
                            <h3 class="font-medium text-base-content">音乐收藏</h3>
                        </div>
                        <div class="text-sm text-base-content/70 mb-4">删除数据库中的数据，方便调试重新导入。</div>
                        
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm focus:select-accent" v-model="formData.backend_task.music_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>
                        
                        <div v-if="formData.backend_task.music_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm focus:input-accent" v-model="formData.backend_task.music_task.cron" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div v-else-if="formData.backend_task.music_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm focus:input-accent" v-model="formData.backend_task.music_task.interval" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div class="flex items-center justify-between pt-2">
                            <div class="flex items-center gap-2">
                                <span class="text-sm font-medium">启用状态</span>
                                <div class="badge badge-sm text-white" :class="formData.backend_task.music_task.enabled ? 'badge-success' : 'badge-error'">
                                    {{ formData.backend_task.music_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="btn btn-sm btn-primary" @click="handleTask2('music', formData.backend_task.music_task)">立即执行</button>
                                <button class="btn btn-sm btn-outline" @click="handleTask2('music', formData.backend_task.music_task, false)">关闭</button>
                            </div>
                        </div>
                        
                        <div class="text-sm text-base-content/70 flex items-center gap-2 pt-2 border-t border-base-300">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.music_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 操作记录 -->
                    <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                        <div class="flex items-center mb-3">
                            <svg class="w-4 h-4 mr-2 text-warning" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                            </svg>
                            <h3 class="font-medium text-base-content">操作记录</h3>
                        </div>
                        <div class="text-sm text-base-content/70 mb-4">删除所有操作记录。</div>
                        
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm focus:select-warning" v-model="formData.backend_task.audit_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>
                        
                        <div v-if="formData.backend_task.audit_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm focus:input-warning" v-model="formData.backend_task.audit_task.cron" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div v-else-if="formData.backend_task.audit_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm focus:input-warning" v-model="formData.backend_task.audit_task.interval" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div class="flex items-center justify-between pt-2">
                            <div class="flex items-center gap-2">
                                <span class="text-sm font-medium">启用状态</span>
                                <div class="badge badge-sm text-white" :class="formData.backend_task.audit_task.enabled ? 'badge-success' : 'badge-error'">
                                    {{ formData.backend_task.audit_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="btn btn-sm btn-primary" @click="handleTask2('audit_log', formData.backend_task.audit_task)">立即执行</button>
                                <button class="btn btn-sm btn-outline" @click="handleTask2('audit_log', formData.backend_task.audit_task, false)">关闭</button>
                            </div>
                        </div>
                        
                        <div class="text-sm text-base-content/70 flex items-center gap-2 pt-2 border-t border-base-300">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.audit_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 播放记录 -->
                    <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                        <div class="flex items-center mb-3">
                            <svg class="w-4 h-4 mr-2 text-info" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293H15M9 10V9a2 2 0 012-2h2a2 2 0 012 2v1m-6 0V9a2 2 0 012-2h2a2 2 0 012 2v1"></path>
                            </svg>
                            <h3 class="font-medium text-base-content">播放记录</h3>
                        </div>
                        <div class="text-sm text-base-content/70 mb-4">删除首页播放记录。</div>
                        
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm focus:select-info" v-model="formData.backend_task.play_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>
                        
                        <div v-if="formData.backend_task.play_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm focus:input-info" v-model="formData.backend_task.play_task.cron" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div v-else-if="formData.backend_task.play_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm focus:input-info" v-model="formData.backend_task.play_task.interval" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div class="flex items-center justify-between pt-2">
                            <div class="flex items-center gap-2">
                                <span class="text-sm font-medium">启用状态</span>
                                <div class="badge badge-sm text-white" :class="formData.backend_task.play_task.enabled ? 'badge-success' : 'badge-error'">
                                    {{ formData.backend_task.play_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="btn btn-sm btn-primary" @click="handleTask2('play_log',formData.backend_task.play_task)">立即执行</button>
                                <button class="btn btn-sm btn-outline" @click="handleTask2('play_log',formData.backend_task.play_task, false)">关闭</button>
                            </div>
                        </div>
                        
                        <div class="text-sm text-base-content/70 flex items-center gap-2 pt-2 border-t border-base-300">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.play_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 刮削记录 -->
                    <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                        <div class="flex items-center mb-3">
                            <svg class="w-4 h-4 mr-2 text-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
                            </svg>
                            <h3 class="font-medium text-base-content">刮削记录</h3>
                        </div>
                        <div class="text-sm text-base-content/70 mb-4">删除所有刮削记录，刮削记录用于标记每个音乐的刮削状态。</div>
                        
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm focus:select-success" v-model="formData.backend_task.tag_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>
                        
                        <div v-if="formData.backend_task.tag_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm focus:input-success" v-model="formData.backend_task.tag_task.cron" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div v-else-if="formData.backend_task.tag_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm focus:input-success" v-model="formData.backend_task.tag_task.interval" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div class="flex items-center justify-between pt-2">
                            <div class="flex items-center gap-2">
                                <span class="text-sm font-medium">启用状态</span>
                                <div class="badge badge-sm text-white" :class="formData.backend_task.tag_task.enabled ? 'badge-success' : 'badge-error'">
                                    {{ formData.backend_task.tag_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="btn btn-sm btn-primary" @click="handleTask2('tag_log',formData.backend_task.tag_task)">立即执行</button>
                                <button class="btn btn-sm btn-outline" @click="handleTask2('tag_log',formData.backend_task.tag_task, false)">关闭</button>
                            </div>
                        </div>
                        
                        <div class="text-sm text-base-content/70 flex items-center gap-2 pt-2 border-t border-base-300">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.tag_task.last_run || '未执行' }}
                        </div>
                    </div>

                    <!-- 不存在的音乐收藏 -->
                    <div class="bg-base-200/50 rounded-lg p-6 space-y-4">
                        <div class="flex items-center mb-3">
                            <svg class="w-4 h-4 mr-2 text-neutral" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                            </svg>
                            <h3 class="font-medium text-base-content">不存在的音乐收藏</h3>
                        </div>
                        <div class="text-sm text-base-content/70 mb-4">在数据库中同步删除不存在或已被删除的音乐。</div>
                        
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行方式</span>
                            </label>
                            <select class="select select-bordered select-sm focus:select-neutral" v-model="formData.backend_task.track_task.type" @change="updateSys('backend_task')">
                                <option value="manual">手动执行</option>
                                <option value="cron">定时执行</option>
                                <option value="interval">周期执行</option>
                            </select>
                        </div>
                        
                        <div v-if="formData.backend_task.track_task.type === 'cron'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">Cron表达式</span>
                            </label>
                            <input type="text" placeholder="Cron表达式" class="input input-bordered input-sm focus:input-neutral" v-model="formData.backend_task.track_task.cron" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div v-else-if="formData.backend_task.track_task.type === 'interval'" class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">执行间隔(分钟)</span>
                            </label>
                            <input type="number" placeholder="间隔(分钟)" class="input input-bordered input-sm focus:input-neutral" v-model="formData.backend_task.track_task.interval" @change="updateSys('backend_task')" />
                        </div>
                        
                        <div class="flex items-center justify-between pt-2">
                            <div class="flex items-center gap-2">
                                <span class="text-sm font-medium">启用状态</span>
                                <div class="badge badge-sm text-white" :class="formData.backend_task.track_task.enabled ? 'badge-success' : 'badge-error'">
                                    {{ formData.backend_task.track_task.enabled ? '运行中' : '已关闭' }}
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="btn btn-sm btn-primary" @click="handleTask2('track_task', formData.backend_task.track_task)">立即执行</button>
                                <button class="btn btn-sm btn-outline" @click="handleTask2('track_task', formData.backend_task.track_task, false)">关闭</button>
                            </div>
                        </div>
                        
                        <div class="text-sm text-base-content/70 flex items-center gap-2 pt-2 border-t border-base-300">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            上次执行时间: {{ formData.backend_task.track_task.last_run || '未执行' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BackgroundTasks',
    props: {
        formData: {
            type: Object,
            required: true
        }
    },
    created() {
        this.getTaskStatus()
    },
    methods: {
        updateSys(key) {
            this.$emit('update-sys', key)
        },
        getTaskStatus() {
            this.$api.Task.periodicTaskStatus().then((res) => {
                if (res.result) {
                    this.formData.backend_task = res.data
                }
            })
        },
        handleTask2(name, item, enabled = true) {
            this.$api.Task.createPeriodicTask({name, ...item, enabled}).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '修改成功！',
                        type: 'success',
                        time: 2000,
                    })
                    this.getTaskStatus()
                }
            })
        },
    }
}
</script> 